import React, { useEffect, useState } from "react";
import { Form, Select, Input, Button, Space, DatePicker } from "antd";
import { circularProgressClasses, Stack } from "@mui/material";
import dayjs from "dayjs"
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  LinearProgress,
  Tooltip
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LinkIcon from "@mui/icons-material/Link";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { setLoading } from "../store/feedback";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import "./createAudit.css";
import data from "./data.json";
import {set_audit_details, set_full_audit_details} from "../store/images"
import { StyledDatePicker, StyledInput, StyledSelect } from "../login-module/customComponents/styled_input";
import { useNavigate, useParams } from "react-router-dom";
const AuditDetails = props => {
  const navigate = useNavigate();
  const { audit_id } = useParams();
  const [userId, setUserId] = useState(null);
  const [isCopied, setIsCopied] = useState(false);
  const [reqUrl, setReqUrl] = useState(null);
  const [dialogSeverity, setDialogSeverity] = useState("success");
  const [openDialog, setOpenDialog] = useState(false);
  const { auditDetails } = useSelector(state => state.imagesStore);

  const dispatch = useDispatch();
  const [selectedMake, setSelectedMake] = useState(null);
  const [selectedModel, setSelectedModel] = useState(null);
  const [models, setModels] = useState([]);
  const [variants, setVariants] = useState([]);
  const share = `${process.env.PUBLIC_URL}/custom-icons/share.svg`;
  const [updatedData, setUpdatedData] = useState({
    "Year of Manufacturing": null,
    "Registration Date": null,
  });
  const [date, setDate] = useState(null);
  const [formattedDate, setFormattedDate] = useState('');


  const handleMakeChange = (type, value) => {
    form.setFieldsValue({ "Model Name": null, "Variant Name": null });
    setSelectedMake(value);
    setSelectedModel(null); // Reset selected model
    setVariants([]); // Reset variants
    const makeData = data.find(item => item.make === value);
    setModels(makeData ? makeData.models : []);
    dispatch(set_audit_details({type,value}))
    // setAuditDetails(prevDetails => ({
    //   ...prevDetails,
    //   [type]: value
    // }));
  };
  console.log(auditDetails, "46");
  const handleModelChange = (type, value) => {
    setSelectedModel(value);
    if (type === "Model") {
      // console.log(type,"50")
      form.setFieldsValue({ "Variant Name": null });
      const modelData = models.find(item => item.model_name === value);
      console.log(modelData, "56");
      setVariants(modelData ? modelData.variants : []);
    }
    dispatch(set_audit_details({type,value}))
    // setAuditDetails(prevDetails => ({
    //   ...prevDetails,
    //   [type]: value
    // }));
  };

  const [dialogWidth, setDialogWidth] = useState("29vw");
  const [dialogText, setDialogText] = useState("0.9rem");

  // const [auditDetails, setAuditDetails] = useState({
  //   Make: null,
  //   Model: null,
  //   Variant: null
  // });
  console.log(auditDetails, "61");
  // const [auditDetails, setAuditDetails] = useState({})
  // const [models, setModels] = useState([]);
  // const [variants, setVariants] = useState([]);
  // useEffect(() => {
  //   if (auditDetails) {
  //     setUpdatedData((prevValues) => ({
  //       ...prevValues,
  //       "Year of Manufacturing": dayjs(auditDetails["Year of Manufacturing"], 'YYYY'),
  //       "Registration Date": dayjs(auditDetails["Registration Date"], 'YYYY-MM-DD'),
  //     }));
  //   }
  // }, [auditDetails]);

  useEffect(() => {
    const handleResize = () => {
      const windowWidth = window.innerWidth;
      if (windowWidth <= 450) {
        setDialogWidth("94vw");
      } else if (windowWidth <= 475) {
        setDialogWidth("94vw");
      } else if (windowWidth <= 570) {
      } else if (windowWidth <= 575) {
        setDialogText("0.6rem");
        setDialogWidth("64vw");
      } else if (windowWidth <= 650) {
        setDialogWidth("60vw");
      } else if (windowWidth <= 700) {
      } else if (window.innerWidth <= 775) {
        setDialogWidth("57vw");
      } else if (window.innerWidth <= 875) {
        setDialogWidth("55vw");
      } else if (windowWidth <= 1000) {
        setDialogWidth("48vw");
      } else if (window.innerWidth <= 1100) {
        setDialogWidth("45vw");
        setDialogText("0.8rem");
      } else if (windowWidth <= 1300) {
        setDialogWidth("40vw");
      } else {
        setDialogWidth("35vw");
      }
    };

    window.addEventListener("resize", handleResize);

    handleResize();

    // Cleanup function to remove event listener
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const generateRandomNDigitString = n => {
    const uuid = uuidv4().replace(/-/g, "");
    const randomString = uuid.substring(0, n);
    return randomString;
  };

  const handleCopy = () => {
    setIsCopied(true)
    navigator.clipboard.writeText(reqUrl)
      .then(() => {
        setIsCopied(true);
        toast.success("Link Copied!", {
          position: "bottom-center",
          autoClose: 1000,
          type: "default",
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          className: "custom-toast",
        });
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  const generateRandomId = () => {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let result = "";

    for (let i = 0; i < 4; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }

    const now = new Date();
    const year = now.getFullYear().toString().slice(-2); // Last 2 digits of year
    const month = (now.getMonth() + 1).toString().padStart(2, "0"); // Month (1-12) padded to 2 digits
    const day = now.getDate().toString().padStart(2, "0"); // Day padded to 2 digits
    const hours = now.getHours().toString().padStart(2, "0"); // Hours padded to 2 digits
    const mins = now.getMinutes().toString().padStart(2, "0"); // Minutes padded to 2 digits

    const secs = now.getSeconds().toString().padStart(2, "0"); // Seconds padded to 2 digits

    const dateTimePart = day + hours + mins + secs;

    result += dateTimePart;
    return result.slice(0, 12);
  };

  const handleInputChange = (type, e) => {
    let value = e.target.value;
    if (type === "Vehicle No") {
      value = e.target.value.toUpperCase();
    }
     dispatch(set_audit_details({type,value}))
    // setAuditDetails(prevDetails => ({
    //   ...prevDetails,
    //   [type]: value
    // }));
  };

  const handleSelectionChange = (type, value) => {
    dispatch(set_audit_details({type,value}))
    // setAuditDetails(prevDetails => ({
    //   ...prevDetails,
    //   [type]: value
    // }));
  };

  const onChangeDateTime = (type, date, dateString) => {
    console.log( dateString,type);
    dispatch(set_audit_details({type,value:moment(dateString)}))
    // setAuditDetails(prevDetails => ({
    //   ...prevDetails,
    //   [type]: dateString
    // }));
  };

  useEffect(() => {
    // generating default info
    const uuid = generateRandomNDigitString(10).toUpperCase();
    setUserId(uuid);
  }, []);
console.log(updatedData)
  useEffect(
    () => {
      let tempAuditDetails = auditDetails;
     dispatch(set_full_audit_details({userId}))
      // setAuditDetails(prevDetails => ({
      //   ...prevDetails,
      //   "User Id": userId,
      //   "Insurance Company": "Future Generali ICL",
      //   "Powered By": "Surveyor AI",
      //   "Dealer Code": "AFA764FA00",
      //   "Inspection Date": moment().format("DD-MM-YYYY"),
      //   "Inspection Time": moment().format("HH:mm"),
      //   "Client Unique Reference No.": generateRandomNDigitString(
      //     10
      //   ).toUpperCase(),
      //   // "PI Type": "Break-in",
      //   // "Proposer Type": ["Individual", "Corporate"],
      //   "Year of Manufacturing": moment().format("YYYY"),
      //   "Report Generate Date & Time": moment(new Date()).format(
      //     "DD MMM, YYYY hh:mm:ss a"
      //   )
      // }));
    },
    [userId]
  );

  const [form] = Form.useForm();

  const showAlert = (severity, message) => {
    setDialogSeverity(severity);
    setOpenDialog(true);
  };

  const handleDialogClose = event => {
    // if (
    //   event.target.tagName.toLowerCase() !== "button" &&
    //   !event.target.closest("button")
    // ) {

    //   return;
    // }
    setOpenDialog(false);
  };

  // const onFinish = async values => {
  //   console.log("Form values:", values);
  //   console.log(audit_id);    
  //   navigate(`/audit/inspection/${audit_id}`)
  //   // props.handleOk();
  // };

  const onFinish = async values => {
    console.log("Form values:", values);
    const audit = generateRandomId();
    console.log(audit);
    try {
      
      const uploadUrl = `https://caiproduction002.blob.core.windows.net/ira/insurance-inspection-details/${audit}.json`;
      console.log(auditDetails);
      const sasToken =
        "?sv=2020-08-04&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2050-05-06T01:59:09Z&st=2022-05-05T17:59:09Z&spr=https&sig=SsFQp5OkIrSG9gVnf4V9F4Vi463mtW25t0Vw2SQzVIM%3D";
      const response = await axios.put(
        `${uploadUrl}${sasToken}`,
        JSON.stringify(auditDetails),
        {
          headers: {
            "x-ms-blob-type": "BlockBlob",
            "Content-Type": "application/json"
          }
        }
      );

      console.log("Upload successful:", response);
      navigate(`/audit/inspection/${audit}`)
      
      dispatch(setLoading(false));
    } catch (err) {
      console.log(err);
      dispatch(setLoading(false));
    }

    // props.handleOk();
  }; 
  console.log("314",auditDetails["Vehicle No"],auditDetails["Model"],auditDetails["Variant"])
  const transformedData = {
    ...auditDetails,
    "Year of Manufacturing": auditDetails["Year of Manufacturing"]!==null && dayjs(auditDetails["Year of Manufacturing"], 'YYYY'),
    "Registration Date":auditDetails["Registration Date"]!==null && dayjs(auditDetails["Registration Date"], 'YYYY-MM-DD')
  };

  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <style jsx>
        {`
          .input-lowercase::placeholder {
            text-transform: capitalize;
          }
        `}
      </style>
      <div
        className="responsive-form-container"
        style={{ display: "flex", flexDirection: "column", gap: "16px" }}
      >
        <Form
          className="form-data"
          form={form}
          onFinish={onFinish}
          layout="vertical"
          // initialValues={auditDetails}
        >
          {/* <div> */}
          <div className="audit-details-group" style={{ width: "80vw" }}>
            <Form.Item
              name="Insurance Company"
              label="Insurance Company"
              style={{ marginBottom: "24px" }}
              rules={[
                {
                  required: true,
                  message: "Please select an insurance company"
                }
              ]}
            >
              <StyledSelect
                value={auditDetails["Insurance Company"]}
                style={{
                  width: 200
                }}
                onChange={e => handleSelectionChange("Insurance Company", e)}
                placeholder="Insurance Company"
                options={[
                  {
                    value: "Surveyor's AI",
                    label: "Surveyor's AI"
                  }
                ]}
              />
            </Form.Item>

            {/* <Stack direction="column" spacing={1}>
              <span className="select-label">Powered By</span>
              <StyledSelect
                defaultValue="Surveyor AI"
                style={{
                  width: 200
                }}
                disabled
                placeholder="Powered By"
                options={[
                  {
                    value: "Surveyor AI",
                    label: "Surveyor AI"
                  }
                ]}
              />
            </Stack> */}

            <Form.Item
              name="Name of Customer"
              label="Name of Customer"
              rules={[
                { required: true, message: "Please enter the Customer Name" }
              ]}
            >
              <StyledInput
              value={auditDetails["Name of Customer"]}
                style={{ width: 200 }}
                placeholder="Enter full name"
                onChange={e => handleInputChange("Name of Customer", e)}
              />
            </Form.Item>

            <Form.Item
              name="Enter Vehicle No."
              label="Enter Vehicle No."
              
              rules={[
                { required: true, message: "Please enter the Vehicle No." }
              ]}
            >
              <StyledInput
               value={auditDetails["Vehicle No"]}
                className="input-lowercase"
                placeholder="Enter Vehicle No."
               
                style={{ width: 200, textTransform: "uppercase" }}
                onChange={e => handleInputChange("Vehicle No", e)}
              />
            </Form.Item>
            <Form.Item
              name="Name of Client"
              label="Name of Client"
              rules={[
                { required: true, message: "Please enter the Client Name" }
              ]}
            >
              <StyledInput
              value={auditDetails["Client Name"]}
                style={{ width: 200 }}
                placeholder="Enter full name"
                onChange={e => handleInputChange("Client Name", e)}
              />
            </Form.Item>
            {/* <Stack direction="column" spacing={1}>
              <span className="select-label">User Id</span>
              <StyledInput
                value={auditDetails["User Id"]}
                style={{ width: 200 }}
                placeholder="User Id"
                disabled
              />
            </Stack> */}

            <Form.Item
              name="Dealer Code"
              label="Dealer Code"
              rules={[
                { required: true, message: "Please select the Dealer Code" }
              ]}
            >
              <StyledSelect
                value={auditDetails["Dealer Code"]}
                style={{ width: 200 }}
                placeholder="Dealer Code"
                options={[{ value: "AFA764FA00", label: "AFA764FA00" }]}
              />
            </Form.Item>

            <Form.Item
              name="Program Name"
              label="Program Name"
              rules={[
                { required: true, message: "Please enter the Program Name" }
              ]}
            >
              <StyledInput
                style={{ width: 200 }}
                value={auditDetails["Program Name"]}
                placeholder="Program Name"
                onChange={e => handleInputChange("Program Name", e)}
              />
            </Form.Item>

            {/* <Stack direction="column" spacing={1}>
              <span className="select-label">Client Unique Reference No.</span>
              <Input
                value={auditDetails["Client Unique Reference No."]}
                style={{ width: 200 }}
                placeholder="Client Unique Reference No."
                disabled
              />
            </Stack> */}

            <Form.Item
              name="PI Type"
              label="PI Type"
              rules={[{ required: true, message: "Please select the PI Type" }]}
            >
              <StyledSelect
                value={auditDetails["PI Type"]}
                style={{ width: 200 }}
                placeholder="PI Type"
                onChange={e => handleSelectionChange("PI Type", e)}
                options={[
                  { value: "Add on", label: "Add on" },
                  {
                    value: "Addition of Bi-fuel Kit",
                    label: "Addition of Bi-fuel Kit"
                  },
                  {
                    value: "Addition of Accessories",
                    label: "Addition of Accessories"
                  },
                  { value: "Break In", label: "Break In" },
                  { value: "Change in Product", label: "Change in Product" },
                  { value: "Cheque Bounce", label: "Cheque Bounce" },
                  { value: "NCB Falsification", label: "NCB Falsification" },
                  { value: "Old Manufacturing", label: "Old Manufacturing" },
                  { value: "Rollover", label: "Rollover" },
                  {
                    value: "Substitution of vechile",
                    label: "Substitution of vechile"
                  },
                  {
                    value: "TP to Comprehensive",
                    label: "TP to Comprehensive"
                  },
                  {
                    value: "Transfer of Ownership",
                    label: "Transfer of Ownership"
                  },
                  { value: "Used Vehicle", label: "Used Vehicle" },
                  { value: "Valuation", label: "Valuation" }
                ]}
              />
            </Form.Item>

            <Form.Item
              name="Proposer Type"
              label="Proposer Type"
              rules={[
                { required: true, message: "Please select the Proposer Type" }
              ]}
            >
              <StyledSelect
                value={auditDetails["Proposer Type"]}
                style={{ width: 200 }}
                placeholder="Proposer Type"
                onChange={e => handleSelectionChange("Proposer Type", e)}
                options={[
                  { value: "Individual", label: "Individual" },
                  { value: "Corporate", label: "Corporate" }
                ]}
              />
            </Form.Item>

            {/* <Stack direction="column" spacing={1}>
              <span className="select-label">Lead Created Date</span>
              <StyledInput
                value={auditDetails["Inspection Date"]}
                style={{ width: 200 }}
                placeholder="Lead created Date"
                disabled
              />
            </Stack>

            <Stack direction="column" spacing={1}>
              <span className="select-label">Lead Created Time</span>
              <StyledInput
                value={auditDetails["Inspection Time"]}
                style={{ width: 200 }}
                placeholder="Lead created Time"
                disabled
              />
            </Stack> */}

            <Form.Item
              name="Vehicle Class"
              label="Vehicle Class"
              rules={[
                { required: true, message: "Please select the Vehicle Class" }
              ]}
            >
              <StyledSelect
                style={{ width: 200 }}
                value={auditDetails["Vehicle Class"]}
                placeholder="Vehicle Class"
                onChange={e => handleSelectionChange("Vehicle Class", e)}
                options={[{ value: "Private", label: "Private" }]}
              />
            </Form.Item>

            <Form.Item
              name="Make"
              label="Make"
              rules={[{ required: true, message: "Please select the Make" }]}
            >
              <StyledSelect
                style={{ width: 200 }}
                placeholder="Make"
                value={auditDetails["Make"]}
                onChange={e => handleMakeChange("Make", e)}
                // options={data.map(item => ({ value: item.make, label: item.make }))}
                options={data
                  .map(item => item.make)
                  .sort()
                  .map(make => ({ value: make, label: make }))}
              />
            </Form.Item>

            <Form.Item
              name="Model Name"
              label="Model Name"
              rules={[
                { required: true, message: "Please select the Model Name" }
              ]}
            >
              <StyledSelect
                style={{ width: 200 }}
                placeholder="Model Name"
                value={auditDetails["Model"]}
                onChange={e => handleModelChange("Model", e)}
                options={models
                  .map(model => model.model_name)
                  .sort()
                  .map(model => ({ value: model, label: model }))}
                disabled={!selectedMake} // Disable if no make is selected
              />
            </Form.Item>

            <Form.Item
              name="Variant Name"
              label="Variant Name"
              rules={[
                { required: true, message: "Please select the Variant Name" }
              ]}
            >
              <StyledSelect
                style={{ width: 200 }}
                placeholder="Variant Name"
                value={auditDetails["Variant"]}
                options={variants
                  .map(variant => variant.variant_name)
                  .sort()
                  .map(variant => ({ value: variant, label: variant }))}
                disabled={!selectedModel} // Disable if no model is selected
                onChange={e => handleModelChange("Variant", e)}
              />
            </Form.Item>

            <Form.Item
              name="Chassis number"
              label="Chassis number"
              rules={[
                { required: true, message: "Please enter the Chassis number" }
              ]}
            >
              <StyledInput
                value={auditDetails["Chassis number"]}
                style={{ width: 200 }}
                placeholder="Chassis number"
                onChange={e => handleInputChange("Chassis number", e)}
              />
            </Form.Item>

            <Form.Item
              name="Engine number"
              label="Engine number"
              rules={[
                { required: true, message: "Please enter the Engine number" }
              ]}
            >
              <StyledInput
                value={auditDetails["Engine number"]}
                style={{ width: 200 }}
                placeholder="Engine number"
                onChange={e => handleInputChange("Engine number", e)}
              />
            </Form.Item>

            <Form.Item
              name="Year of Manufacturing"
              label="Year of Manufacturing"
              rules={[
                {
                  required: true,
                  message: "Please select the Year of Manufacturing"
                }
              ]}
            >
              <StyledDatePicker
                onChange={(date, dateString) =>
                  onChangeDateTime("Year of Manufacturing", date, dateString)}
                picker="year"
                inputReadOnly
                // value={auditDetails["Year of Manufacturing"] ? dayjs(auditDetails["Year of Manufacturing"], 'YYYY') : null}
              />
            </Form.Item>

            <Form.Item
              name="Registration Date"
              label="Registration Date"
              rules={[
                { required: true, message: "Please select the Registration Date" }
              ]}
            >
              <StyledDatePicker
                format="DD-MM-YYYY"
                // value={auditDetails["Registration Date"] && auditDetails["Registration Date"]}
                inputReadOnly
                onChange={(date, dateString) =>
                  onChangeDateTime("Registration Date", date, dateString)}
              />
            </Form.Item>

            {/* <Stack direction="column" spacing={1}>
              <span className="select-label">
                Report Generation Date & Time
              </span>
              <StyledInput
                value={auditDetails["Report Generate Date & Time"]}
                style={{ width: 200 }}
                placeholder="Report Generate Date &Time"
                disabled
              />
            </Stack> */}
          </div>
          <div
            //  className="submit-button-container"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              marginTop: "20px",
              // margin :"20px auto"
              // height: '100%'
            }}
          >
            <Form.Item style={{ margin: "0px" }}>
              <Button
                style={{
                  backgroundColor: "#FF0083",
                  color: "#FFFFFF",
                  minHeight: "40px"
                }}
                htmlType="submit"
              >
                Proceed to choose inspection method
              </Button>
            </Form.Item>
          </div>
          {/* </div> */}
        </Form>
      </div>
      {/* <Dialog
        open={openDialog}
        onClose={handleDialogClose}
        maxWidth="150vw"
        maxHeight="lg"
        PaperProps={{
          style: {
            width: dialogWidth,
            padding: "1.5rem 1rem",
            paddingBottom: "0.5rem",
            borderRadius: "4px",
            margin: "0px",
            height: "265px"
          },
        }}
      >
        <DialogTitle
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: "1rem",
            fontSize: "1.7rem",
            textAlign: "center",
            color: "black",
            padding: "2rem 0.6rem 1rem 0.6rem",
            fontWeight: "600",
            fontFamily: 'Barlow Condensed',
          }}
        >
          {dialogSeverity === "success"
            ? "Audit created successfully"
            : "Error"}
          <button style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.2rem", border: "1.5px solid #FF0083", padding: "0.2rem 1.2rem", backgroundColor: "white", borderRadius: "5px", width: "100%" }}>
            <img src={share} style={{ width: "1rem", height: "1rem" }}></img>
            <p style={{ fontSize: "1rem", fontFamily: "'Montserrat', sans-serif", color: "#FF0083", padding: "0.5rem", cursor: "pointer" }} onClick={handleCopy} >Copy Link</p>
          </button>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleDialogClose}
          sx={{
            position: "absolute",
            right: 14,
            top: 30,
            color: "black",

          }}
        >
          <CloseIcon />
        </IconButton>
      
        <div style={{ padding: "1rem 0.5rem 0.1rem" }}>
          <p
            style={{
              color: "#FF0083",
              textDecoration: "underline",
              fontFamily: "'Montserrat', sans-serif",
              marginBottom: "2px",
              wordBreak: "break-word",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              cursor: "pointer"
            }}
            onClick={() => window.open(reqUrl, "_blank")}
          >
            {reqUrl}
          </p>
        </div>


        <DialogContent style={{ padding: "0.5rem" }}>
          

        </DialogContent>
      </Dialog> */}
      <div style={{ position: "relative" }}>
        <ToastContainer />
        <Dialog
          open={openDialog}
          onClose={handleDialogClose}
          maxWidth="150vw"
          maxHeight="lg"
          PaperProps={{
            style: {
              width: dialogWidth,
              padding: "1.5rem 1rem",
              paddingBottom: "0.5rem",
              borderRadius: "4px",
              margin: "0px",
              height: "265px",
              zIndex: "999999"
            },
          }}
        >
          <DialogTitle
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              gap: "1rem",
              fontSize: "1.7rem",
              textAlign: "center",
              color: "black",
              padding: "2rem 0.6rem 1rem 0.6rem",
              fontWeight: "600",
              fontFamily: 'Barlow Condensed',
            }}
          >
            {dialogSeverity === "success"
              ? "Audit created successfully"
              : "Error"}
            <button
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "0.2rem",
                border: "1.5px solid #FF0083",
                padding: "0.2rem 1.2rem",
                backgroundColor: "white",
                borderRadius: "5px",
                width: "100%",
                cursor: "pointer"
              }}
              onClick={handleCopy}
            >
              <img src={share} style={{ width: "1rem", height: "1rem" }} alt="Share Icon" />
              <p
                style={{
                  fontSize: "1rem",
                  fontFamily: "'Montserrat', sans-serif",
                  color: "#FF0083",
                  padding: "0.5rem",
                  cursor: "pointer",
                }}
              >
                Copy Link
              </p>
            </button>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleDialogClose}
            sx={{
              position: "absolute",
              right: 14,
              top: 30,
              color: "black",
            }}
          >
            <CloseIcon />
          </IconButton>

          <div style={{ padding: "1rem 0.5rem 0.1rem" }}>
            <p
              style={{
                color: "#FF0083",
                textDecoration: "underline",
                fontFamily: "'Montserrat', sans-serif",
                marginBottom: "2px",
                wordBreak: "break-word",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                cursor: "pointer",
              }}
              onClick={() => window.open(reqUrl, "_blank")}
            >
              {reqUrl}
            </p>
          </div>

          <DialogContent style={{ padding: "0.5rem" }}>
            {/* Additional content can go here */}
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
};

export default AuditDetails;
